import AnalyticsEvent from './analyticsEvent';

const aiRecommendationEvents = {
  aiRecommendationClick: (
    tags: Array<string>,
    position: number
  ): AnalyticsEvent =>
    AnalyticsEvent.createEvent('ai_reco_clicked', { tags, position }),
};

export default aiRecommendationEvents;
